import {makeStyles} from '@mui/styles';

const useStyles = makeStyles((theme) => ({

  burgerMenuToggler: {
    display: "none",
    "@media screen and (max-width: 480px)": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "0 2px"
    }
  },

}));

export default useStyles;
